import { Box, Typography } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledProductReleaseTag = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1, 3),
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2.5),
  borderRadius: theme.spacing(7),
  width: 'fit-content',
  background: theme.palette.admin.primary,
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    marginInline: 'auto',
  },
}));

export const StyledProductReleaseTagLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(14),
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '150%',
  letterSpacing: '0.07px',
}));
